import React from 'react';
import './styles/App.css';
import { PageLayout } from './components/PageLayout';
import Landing from './pages/landing';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthenticatedRoutes from './AuthenticatedRoutes'; // Separate file for handling tenant logic
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

const MainContent = () => {
    return (
        <div className="App">
            <Router>
                <AuthenticatedTemplate>
                    <AuthenticatedRoutes />
                </AuthenticatedTemplate>

                <UnauthenticatedTemplate>
                    <Routes>
                        <Route exact path="/" element={<Landing />} />
                    </Routes>
                </UnauthenticatedTemplate>
            </Router>
        </div>
    );
};

export default function App() {
    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />
            <MainContent />
        </>
    );
}